<script setup lang="ts">
import { SelectIcon, SelectTrigger, type SelectTriggerProps, useForwardProps } from 'radix-vue'
import { type HTMLAttributes, computed } from 'vue'

import { Icon } from '@/ui'
import { cn } from '@/utils'

const props = defineProps<SelectTriggerProps & { class?: HTMLAttributes['class']; error?: boolean }>()

const delegatedProps = computed(() => {
  const { class: _, error: _error, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectTrigger
    v-bind="forwardedProps"
    tabindex="-1"
    :class="
      cn(
        'border-input ring-offset-background focus:ring-ring data-placeholder:text-muted-foreground flex h-10 w-full items-center justify-between rounded-md border px-3 py-2 text-start text-sm focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate',
        props.class,
        { 'border-red-500 text-red-500': props.error }
      )
    "
  >
    <slot />
    <SelectIcon as-child>
      <Icon name="ChevronDownIcon" class="ml-3 size-4 shrink-0 opacity-50" />
    </SelectIcon>
  </SelectTrigger>
</template>
